import React from "react";
import { Users, SunMedium, Zap, Award } from "lucide-react";
import { stats } from "../mock";

const iconMap = { Users, SunMedium, Zap, Award };

const Stats = () => {
  return (
    <section className="pb-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-[#0f2a5c] rounded-xl px-6 md:px-10 py-8 grid grid-cols-2 md:grid-cols-4 gap-6 shadow-lg">
          {stats.map((st) => {
            const Icon = iconMap[st.icon];
            return (
              <div key={st.id} className="flex items-center gap-4 justify-center md:justify-start">
                <Icon className="w-10 h-10 text-[#F5B800] flex-shrink-0" strokeWidth={1.6} />
                <div>
                  <div className="text-white text-3xl font-extrabold leading-none">{st.value}</div>
                  <div className="text-slate-200 text-xs mt-1 font-medium">{st.label}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Stats;
